import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../../services/api';
import { FiPlus, FiEdit, FiTrash2, FiX } from 'react-icons/fi';
import './Management.css';

const InstagramReelsManagement = () => {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingReel, setEditingReel] = useState(null);
  const [formData, setFormData] = useState({
    reel_url: '',
    embed_code: '',
    order: 0,
    is_active: true,
  });

  useEffect(() => {
    loadReels();
  }, []);

  const loadReels = async () => {
    try {
      const response = await adminAPI.getAllInstagramReels();
      setReels(response.data);
    } catch (error) {
      console.error('Error loading Instagram reels:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingReel) {
        await adminAPI.updateInstagramReel(editingReel.id, formData);
      } else {
        await adminAPI.createInstagramReel(formData);
      }
      loadReels();
      resetForm();
    } catch (error) {
      alert('Error al guardar el reel');
      console.error(error);
    }
  };

  const handleEdit = (reel) => {
    setEditingReel(reel);
    setFormData({
      reel_url: reel.reel_url || '',
      embed_code: reel.embed_code || '',
      order: reel.order || 0,
      is_active: reel.is_active,
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este reel?')) {
      try {
        await adminAPI.deleteInstagramReel(id);
        loadReels();
      } catch (error) {
        alert('Error al eliminar el reel');
      }
    }
  };

  const resetForm = () => {
    setFormData({
      reel_url: '',
      embed_code: '',
      order: 0,
      is_active: true,
    });
    setEditingReel(null);
    setShowForm(false);
  };

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="management">
      <div className="management-header">
        <h1>Gestión de Instagram Reels</h1>
        <button className="btn-primary" onClick={() => setShowForm(true)}>
          <FiPlus /> Nuevo Reel
        </button>
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={resetForm}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingReel ? 'Editar' : 'Nuevo'} Reel</h2>
              <button className="close-btn" onClick={resetForm}>
                <FiX />
              </button>
            </div>
            <form onSubmit={handleSubmit} className="form">
              <div className="form-group">
                <label>URL del Reel *</label>
                <input
                  type="url"
                  value={formData.reel_url}
                  onChange={(e) => setFormData({ ...formData, reel_url: e.target.value })}
                  placeholder="https://www.instagram.com/reel/..."
                  required
                />
              </div>
              <div className="form-group">
                <label>Código de Embed (HTML) *</label>
                <textarea
                  value={formData.embed_code}
                  onChange={(e) => setFormData({ ...formData, embed_code: e.target.value })}
                  rows="6"
                  placeholder='<blockquote class="instagram-media"...</blockquote>'
                  required
                />
                <small>Pega aquí el código de embed de Instagram</small>
              </div>
              <div className="form-group">
                <label>Orden</label>
                <input
                  type="number"
                  value={formData.order}
                  onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
                />
              </div>
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.is_active}
                    onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                  />
                  Activo
                </label>
              </div>
              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={resetForm}>
                  Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>URL</th>
              <th>Orden</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {reels.map((reel) => (
              <tr key={reel.id}>
                <td>{reel.id}</td>
                <td className="file-path">{reel.reel_url}</td>
                <td>{reel.order}</td>
                <td>{reel.is_active ? 'Activo' : 'Inactivo'}</td>
                <td>
                  <button
                    className="btn-icon"
                    onClick={() => handleEdit(reel)}
                    title="Editar"
                  >
                    <FiEdit />
                  </button>
                  <button
                    className="btn-icon btn-danger"
                    onClick={() => handleDelete(reel.id)}
                    title="Eliminar"
                  >
                    <FiTrash2 />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InstagramReelsManagement;

